import {z} from "zod"
import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {AddressMode, size2Like, vector2Like} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"
import {extRegion} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/extract-region/definition"
import {imageOpHalOptions} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/hal/image-op-hal-types"

export const Definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            imageOpHalOptions: imageOpHalOptions,

            sourceImage: anyImageOpResult,
            sourceRegion: extRegion.optional(), // default: {x: 0, y: 0, width: sourceImage.width, height: sourceImage.height}; offset can be a 1x1 >=2-channel image
            patchSize: size2Like,
            stride: vector2Like.optional().default({x: 1, y: 1}),
            addressMode: AddressMode.optional().default("wrap"),
        }),
    },
}
